/**
 * Group identical readiness warnings for display without changing the
 * server-provided warning list or its total count.
 */
export const groupReadinessWarnings = (warnings = []) => {
  const groups = new Map();

  (Array.isArray(warnings) ? warnings : []).filter(Boolean).forEach((warning) => {
    const key = [
      warning.code,
      warning.resourceType,
      warning.resourceId,
      warning.flowId,
      warning.nodeId,
      warning.message,
    ].map((value) => String(value || '')).join('\u001f');

    const existing = groups.get(key);
    if (existing) {
      existing.count += 1;
    } else {
      groups.set(key, { ...warning, count: 1 });
    }
  });

  return Array.from(groups.values());
};
